import React from 'react';
import PieChart, {
    Legend,
    Export,
    Series,
    Label,
    Font,
    Connector,
} from 'devextreme-react/pie-chart';

function customizeText(arg: { valueText: string; percentText: string; }) {
    return `${arg.valueText} (${arg.percentText})`;
}

interface PieChartProps {
    data: any;
    title: string;
}

function App(props: PieChartProps) {
    const { data, title } = props;

    return (
        <PieChart id="pie"
            palette="Bright"
            dataSource={data}
            title={title} >
            <Legend
                orientation="horizontal"
                itemTextPosition="right"
                horizontalAlignment="center"
                verticalAlignment="bottom"
                columnCount={4} />
            <Export enabled={true} />
            <Series argumentField="label" valueField="value">
                <Label
                    visible={true}
                    position="columns"
                    customizeText={customizeText}>
                    <Font size={16} />
                    <Connector visible={true} width={0.5} />
                </Label>
            </Series>
        </PieChart>
    );
}

export default App;
